<template>
    <div v-show="isModalExistingGroupVisible">
        <transition name="slide">
            <div class="modal-mask">
                <div class="modal-dialog modal-dialog-slideout modal-lg">
                    <div class="modal-content p-2">
                        <div class="modal-header">
                            <div class="maheading_1">
                                <i class="fa fa-chevron-left modal-goback" @click="close"></i>
                            </div>
                            <div class="maheading_2">
                                <h5 class="modal-title">{{ group_name_text }}</h5>
                            </div>
                            <div class="maheading_3">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div v-if="updateMsg" class="text-green">{{ updateMsg }}</div>
                            <form>
                                <div class="row">
                                    <div class="col-12">
                                        <label class="form-label">Group Name</label>
                                        <input
                                            type="text"
                                            id="group_name"
                                            class="col-12 col-sm-12 ma-input-field"
                                            ref="group_name"
                                            name="group_name"
                                            v-model="group_name"
                                            v-validate="{ rules: { required: true, regex: nameRegex() } }"
                                            placeholder="Enter Group Name"
                                            maxlength="250"
                                            autocomplete="off">
                                        <div v-if="verrors.firstByRule('group_name', 'required')" class="margin-bottom-5 validate-warning-msg">Group name is required</div>
                                        <div v-if="verrors.firstByRule('group_name', 'regex')" class="margin-bottom-5 validate-warning-msg">Group name should only contain - and _</div>
                                        <div v-if="groupExists" class="text-red">{{ groupExists }}</div>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div v-show="loading" class="loading_show col-12"><div class="spinner-border text-danger"></div></div>
                                    <div class="col-12">
                                        <label class="form-label">Accounts in Group</label>
                                    </div>
                                    <div class="row edit_row">
                                        <div class="col-12">
                                            <div v-if="groupLinkedAccountsResults.length > 0" class="row_item_readonly">
                                                <div class="row_data_border" v-for="(accName, index) in groupLinkedAccountsResults" :key="index">
                                                    <div class="linked_group_account_1">{{ accName }}</div>
                                                    <div class="clearfix"></div>
                                                </div>
                                            </div>
                                            
                                            <div class="row_item_readonly justify-content-md-center">
                                                <div class="text-blue m-4">{{ getNoRecordText() }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-8">
                                        <label class="form-label">Add Accounts to Group</label>
                                    </div>
                                    <div class="col-4">
                                        <input
                                            type="text"
                                            name="org name"
                                            id="org_name"
                                            class="search_org_text"
                                            ref="org_name"
                                            v-model="org_name"
                                            maxlength="250"
                                            @keyup.enter="setLocationFilterbyName">
                                            <span class="search-icon" @click="setLocationFilterbyName">
                                            <i class="fa fa-search search_icons"></i>
                                        </span>
                                    </div>
                                    <div class="row edit_row">
                                        <div class="col-12">
                                            <div v-if="locations.length > 0" class="row_item_readonly">
                                                <div class="row_data_border" v-for="(item, aindex) in locations" :key="aindex">
                                                    <div class="location_item_1">
                                                        <input 
                                                            type="checkbox" 
                                                            :name="'assign_accounts_' + aindex"
                                                            :id="'assign_accounts_' + aindex"
                                                            :value="item.accId"
                                                            v-model="accountsSelected">
                                                    </div>
                                                    <div class="location_item_2">{{ item.accountName }}</div>
                                                    <div class="location_item_3">{{ (item.city) ? item.city : "&nbsp;" }}</div>
                                                    <div class="location_item_4">{{ (item.stateCode) ? item.stateCode : "&nbsp;" }}</div>
                                                    <div class="clearfix"></div>
                                                </div>
                                            </div>
                                            <div v-if="accountSelectedErrorMsg" class="text-error">{{ accountSelectedErrorMsg }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-md-end mr-1">
                                    <div v-if="rows > 25" class="overflow-auto float-right pagination-wrapper">
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="rows"
                                            :per-page="perPage"
                                            first-text="First"
                                            prev-text="Prev"
                                            next-text="Next"
                                            last-text="Last"
                                            :hide-goto-end-buttons=false
                                            @input="showLocationsPaginated()"
                                        ></b-pagination>
                                    </div>
                                </div>
                                <div class="row submit_row justify-content-md-center">
                                    <div class="col-6">
                                        <button type="button" class="btn btn-sm btn-blue saveBtn text-center" @click="saveGroup">Save</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalExistingGroupVisible', 'accountId'],
    data() {
        return {
            loading: false,
            group_name_text: '',
            group_name: '',
            group_id: '',
            rows: 0,
            perPage: 25,
            currentPage: 1,
            publicSortBy: '',
            sortField: '',
            locationsCount: 0,
            locations: [],
            accountsSelected: [],
            org_name: '',
            groupLinkedAccountsResults: [],
            groupExists: '',
            updateMsg: '',
            main_locations: [],
            accountSelectedErrorMsg: '',
        }
    },
    methods: {
        close() {
            let routeData = this.$router.resolve({name: 'locations'});
            window.open(routeData.href, '_self');
        },
        getGroupData(groupId, groupName) {
            this.group_name = groupName;   
            this.group_name_text = groupName;
            this.group_id = groupId;
            this.fetchLocationsListitems();
        },
        nameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        fetchLocationsListitems() {
            this.loading = true;
            this.locations = [];
            this.groupLinkedAccountsResults = [];
            if(this.filterFlag) {
                this.currentPage = 1;
            }
            const params = { page: this.currentPage, group_id: this.group_id }
            if (this.sortField) {
                params.sortfield = this.sortField
            }
            if (this.publicSortBy) {
                params.sortby = this.publicSortBy
            }
            params.org_name = this.org_name;
            axios('/enterprise-admin/groups-linked-locations',
            {
                method: 'POST',
                data: {
                    'search_parameters': params
                }
            })
            .then(response => {
                this.updateMsg = '';
                this.loading = false;
                this.locationsCount = response.data.data.length;
                this.locations = response.data.data;
                this.rows = response.data.total_rows;
                this.groupLinkedAccountsResults = response.data.groupLinkedAccountsResults;
                this.main_locations = response.data.data;
            })
            .catch(() => {
            });
        },
        showLocationsPaginated() {
            this.fetchLocationsListitems();
            this.filterFlag = false;
        },
        saveGroup() {
            this.accountSelectedErrorMsg = '';
            this.groupExists = '';
            this.$validator.validateAll().then((result) => {
                if (this.verrors.items.length === 0 && this.accountsSelected.length > 0) {
                    this.loading = true;
                    axios('/enterprise-admin/update-group', 
                    {
                        method: 'PATCH',
                        data: {
                            group_name: this.group_name,
                            group_id: this.group_id,
                            accountsSelected: this.accountsSelected,
                        },
                    })
                    .then((resp) => {
                        this.loading = false;
                        this.verrors.clear();
                        this.updateMsg = "Group updated successfully";
                        this.group_name_text = this.group_name;
                        this.fetchLocationsListitems();
                    })
                    .catch(error => {
                        if(error.response) {
                            const fieldErrors =  [];
                            var errMsgObj = error.response.data.message.group_name;
                            this.groupExists = errMsgObj;
                        }
                    });
                } else {
                    this.accountSelectedErrorMsg = "Please add a accounts to Group";
                }
            });
        },
        getNoRecordText() {
            if (this.loading) {
                return '';
            } else {
                if (this.groupLinkedAccountsResults.length == 0 && this.group_id) {
                    return 'No Accounts in Group';
                }
            }
        },
        setLocationFilterbyName() {
            if (this.org_name) {
                this.locations = this.main_locations.filter(account => account.accountName.toLowerCase().includes(this.org_name.toLowerCase()));
            } else {
                this.locations = this.main_locations;
                this.accountSelectedErrorMsg = '';
            }
        }
    },
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.saveBtn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 100%;
}
.closeBtn {
    color: #00acee; 
    background-color: #FFF !important;
    border: 1px solid #00acee !important;
    border-radius: 10px;
    font-weight: 900;
    width: 100%;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  background-color: #efefef;
  min-height: 30px;
  border-radius: 5px;
}
.ma-input-field:focus-visible {
  outline: none;
}
.form-label { font-size: 13px; font-weight: 900; } 
.submit_row { margin: 4rem; }
.successPanel { 
    background-color: #28a745;
    color: #FFF;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
}
.success-msg { font-size:  1.5rem; font-weight: 900;}
.success-note i { font-size: 1.25rem; margin-right: 10px; }
.gotoBtn { margin-top: 16rem; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.location_item_1 { width: 5%; float: left; }
.location_item_2 { width: 65%; float: left; }
.location_item_3 { width: 15%; float: left; }
.location_item_4 { width: 15%; float: left; }
.row_item_readonly { width: 100%; }
.row_data_border { padding: 5px 0; margin-bottom: 5px; font-size: 14px;}
.row_data_border:nth-last-child(1) { border-bottom: 1px solid rgba(0, 0, 0, 0.1); }
.edit_row { width: 100%; margin-left: 0px; }
.linked_group_account_1 { width: 100%; float: left; }
.text-blue { text-align: center; color: #00acee !important; font-weight: 900; font-style: italic; }
.loading_show { height: auto; }
.search_icons { font-size: 1.5rem; color: #bfbfbf; }
.search_org_text { width: 120px;outline: 0; border-width: 0 0 1px; border-color: #000; background-color: #FFF; }
.text-error { color: #FF0000; }
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/existing_group.vue